import axios from 'axios';
import { reportError } from "./sentry";

const generateAssessmentSummary = async (payload) => {

  let apiUrlBase = "https://microservice.flowspeak.io/";
  const apiUrlString = "api/v2/assessment_summary";

  // Temp
  apiUrlBase = "https://nvl-api-microservice-eu-da212da708e1.herokuapp.com/";

  // // -------------------------------------
  // // For testing and staging
  // // -------------------------------------
  // const host = window.location.host;
  // const onStaging = host.search('--flow-web.netlify.app') > 0;
  // if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development' || onStaging) {

  //   // apiUrlBase = "https://nvl-api-microservice-staging.herokuapp.com/";
  //   apiUrlBase = "http://localhost:8080/";
  // }
  // // -------------------------------------


  // Define variables
  const apiUrl = `${apiUrlBase}${apiUrlString}`;
  const url = encodeURI(apiUrl);

  const formData = new FormData();
  const apiKey = "fs000000000003044092320002333";

  formData.append('payload', JSON.stringify(payload));


  const config = {
    method: 'post',
    url: url,
    headers: {
      authorization: `Bearer ${apiKey}`,
      "Content-Type": "multipart/form-data",
     },
    data : formData,
  };


  return axios(config).then(function (response) {
    if( response?.data ) {
      return response.data;
    } else {
      reportError("Generate Assessment Summary")
    }
  }).catch(function (error) {
    reportError(error);
    return { success: false, error: error}
  });

}

export default generateAssessmentSummary;